import { render, staticRenderFns } from "./FirstToolbarComponent.vue?vue&type=template&id=167e3635&scoped=true"
import script from "./FirstToolbarComponent.vue?vue&type=script&lang=ts"
export * from "./FirstToolbarComponent.vue?vue&type=script&lang=ts"
import style0 from "./FirstToolbarComponent.vue?vue&type=style&index=0&id=167e3635&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167e3635",
  null
  
)

export default component.exports